module.exports = __webpack_public_path__ + "img/amex.d06ee9b4.png";